import React, { useState, useEffect } from 'react';
import '../css/FAQ.css'; // Import du fichier CSS
import { useAuth } from '../AuthContext'; // Import du contexte d'authentification

const FAQ = () => {
  const { isAdmin } = useAuth(); // Vérification si l'utilisateur est admin
  const [faq, setFaq] = useState([]);
  const [reponse, setReponse] = useState('');
  const [loading, setLoading] = useState(true);
  const [questionUtilisateur, setQuestionUtilisateur] = useState('');
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  // Récupération des questions/réponses
  useEffect(() => {
    fetch('https://carto.api.toobib.org/api/faq')
      .then(res => res.json())
      .then(data => {
        setFaq(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur de chargement de la FAQ :', err);
        setLoading(false);
      });
  }, []);

  // Soumettre une réponse (admin uniquement)
  const handleReponseSubmit = (id) => {
    if (!reponse) {
      alert('Veuillez entrer une réponse.');
      return;
    }

    fetch(`https://carto.api.toobib.org/api/faq/repondre_question/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ reponse }),
    })
      .then(res => res.json())
      .then(data => {
        const nouvelleFaq = faq.map(item =>
          item.id === id ? { ...item, reponse: data.reponse, repondu: true, date_reponse: data.date_reponse } : item
        );
        setFaq(nouvelleFaq);
        setReponse('');
      })
      .catch(err => {
        console.error('Erreur lors de la réponse :', err);
      });
  };

  const handleQuestionSubmit = () => {
    if (!questionUtilisateur) {
      alert('Veuillez saisir une question.');
      return;
    }

    fetch('https://carto.api.toobib.org/api/faq/poser_question', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: questionUtilisateur }),
    })
      .then(res => res.json())
      .then(data => {
        setFaq([data, ...faq]);
        setQuestionUtilisateur('');
      })
      .catch(err => console.error('Erreur lors de l\'envoi de la question :', err));
  };

  const toggleQuestion = (id) => {
    setExpandedQuestion(expandedQuestion === id ? null : id);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="faq-loading">
        <div className="faq-spinner"></div>
      </div>
    );
  }

  return (
    <div className="faq-container">
      <h1 className="faq-title">Foire Aux Questions</h1>
      
      

      {/* Liste des questions/réponses */}
      <div className="faq-list">
        {faq.length === 0 ? (
          <p className="faq-empty">Aucune question n'a été posée pour le moment.</p>
        ) : (
          faq.map((item) => (
            <div key={item.id} className="faq-item">
              <div 
                className="question-header" 
                onClick={() => toggleQuestion(item.id)}
              >
                <div className="question-text">{item.question}</div>
                <div className="question-meta">
                  <span className={`question-status ${item.repondu ? 'status-answered' : 'status-pending'}`}>
                    {item.repondu ? 'Répondu' : 'En attente'}
                  </span>
                  <span>{formatDate(item.date_question)}</span>
                </div>
              </div>
              
              {expandedQuestion === item.id && (
                <div className="answer-content">
                  {item.repondu ? (
                    <>
                      <div className="answer-meta">
                        <span>Réponse de: <strong>Admin</strong></span>
                        <span>{formatDate(item.date_reponse)}</span>
                      </div>
                      <div className="answer-text">{item.reponse}</div>
                    </>
                  ) : isAdmin ? (
                    <div className="answer-form">
                      <textarea
                        value={reponse}
                        onChange={(e) => setReponse(e.target.value)}
                        placeholder="Votre réponse..."
                      />
                      <button onClick={() => handleReponseSubmit(item.id)}>
                        Publier la réponse
                      </button>
                    </div>
                  ) : (
                    <div className="answer-text">En attente de réponse d'un administrateur...</div>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
      {/* Formulaire pour poser une question */}
      <div className="question-form">
        <h2>Poser une question</h2>
        <div className="question-input">
          <input
            type="text"
            value={questionUtilisateur}
            onChange={(e) => setQuestionUtilisateur(e.target.value)}
            placeholder="Votre question..."
          />
          <button onClick={handleQuestionSubmit}>
            Envoyer
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;